import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
  editData: [],
};

export const LabFormSlice = createSlice({
  name: "LabFormReducer",
  initialState,
  reducers: {
    setLabData: (state, action) => {
      state.editData = action.payload;
    },

    resetState: (state) => {
      state.editData = {};
    },
  },
});

export const { setLabData, resetState } = LabFormSlice.actions;

export default LabFormSlice.reducer;
